import { Component } from '@grafikr/components'
import { setCookie, getCookie } from '../lib/utils'
import sscroll from 'sscroll'

export default Component((node, { app, dispatchEvent }) => {
  const
    openIcon = node.querySelector('[data-mobile-menu-open]'),
    menu = document.querySelector('[data-mobile-menu]'),
    closeIcon = menu.querySelector('[data-mobile-menu-close]')


  if (openIcon) {
    openIcon.addEventListener('click', () => {
      menu.classList.add('open')
      document.body.classList.add('no-scroll')
    })
  }

  closeIcon.addEventListener('click', () => {
    menu.classList.remove('open')
    document.body.classList.remove('no-scroll')
  })

  /**
   * Toggle second mobile menu
   */
  const
    secondMenus = node.querySelectorAll('[data-second-menu]'),
    secondMenuBacks = node.querySelectorAll('[data-second-menu-back]'),
    secondMenuCloses = node.querySelectorAll('[data-second-menu-close]'),
    mbMenuLinks = [...node.querySelectorAll('[data-mobile-menu-link]')],
    linksWithSecondMenus = mbMenuLinks.filter(link => link.classList.contains('has-second-menu'))

  secondMenus.forEach(i => {
    if (i.querySelector("[href='"+ window.location.pathname +"']")) {
      i.querySelector("[href='"+ window.location.pathname +"']").classList.add('active')
      i.classList.add('open')
    }
  })

  if (linksWithSecondMenus.length > 0) {
    linksWithSecondMenus.forEach((link, i) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()

        secondMenus[i].classList.add('open')
      })
    })
  }

  secondMenuBacks.forEach((secondMenuBack, i) => {
    secondMenuBack.addEventListener('click', () => {
      secondMenus[i].classList.remove('open')
    })
  })

  secondMenuCloses.forEach(secondMenuClose => {
    secondMenuClose.addEventListener('click', () => {
      secondMenus[i].classList.remove('open')
      menu.classList.remove('open')
    })
  })

    /**
     * Change header background when hover on menu-items
     */

    if (getCookie('visitorReg') === "GB") {
        document.body.classList.add('isUK')
    }

    const
        menuLinks = node.querySelectorAll('[data-menu-link]'),
        body = document.body,
        searchDropdown = document.querySelector('[data-search-dropdown]'),
        megamenu = node.querySelectorAll('.megamenu')

    menuLinks.forEach(link => {
        link.addEventListener('mouseover', () => {
            body.classList.add('item-hover')

            if (link.classList.contains('has-megamenu')) node.classList.add('megamenu-open')
        })

        link.addEventListener('mouseleave', () => {
            if (!searchDropdown.classList.contains('open')) body.classList.remove('item-hover')

            node.classList.remove('megamenu-open')
        })
    })

    megamenu.forEach(m => {
        m.addEventListener('mouseover', () => {
            body.classList.add('item-hover')
            node.classList.add('megamenu-open')
        })

        m.addEventListener('mouseleave', () => {
            if (!searchDropdown.classList.contains('open')) body.classList.remove('item-hover')

            node.classList.remove('megamenu-open')
        })
    })

    /**
     * Toggle cart
     */
    const
        cartCounts = document.querySelectorAll('[data-cart-count]'),
        cartToggles = document.querySelectorAll('[data-cart-drawer-toggle]')

    for (let i = 0; i < cartToggles.length; i++) {
        cartToggles[i].addEventListener('click', (e) => {
            e.preventDefault()

            dispatchEvent('cart:toggle', {
                cartOpen: !window.theme.cartOpen,
            })
        })
    }

    document.addEventListener('cart:fetched', (e) => {
      const cart = e.detail?.cart || e.detail
      cartCounts.forEach((cartCount) => {
        cartCount.innerHTML = cart.item_count
      })
    })

    cartCounts.forEach(cartCount => {
        cartCount.innerHTML = window.theme?.cart?.item_count || 0
    })

    /**
     * Open cart-drawer when redirected from /cart
     */
    function redirectCart() {
        const
            currentUrl = window.location.href,
            urlParam = currentUrl.split('/'),
            urlCart = urlParam[urlParam.length - 1] === 'cart'

        if (urlCart === true) {
            location.href = '/'
        }

        const
            prevUrl = document.referrer,
            prevUrlParam = prevUrl.split('/'),
            prevUrlCart = prevUrlParam[prevUrlParam.length - 1] === 'cart'

        if (prevUrlCart === true) {
            dispatchEvent('cart:toggle', {
                cartOpen: true,
            })
        }
    }
    redirectCart()

    /**
     * Explore button on hero
     */

    const button = document.querySelector('.hero__explore')
    if (button) {
        button.addEventListener('click', function () {
            const section = button.closest('.shopify-section')

            sscroll(section.nextElementSibling, {
                duration: 700,
                offset: -50
            })
        })
    }


    /**
     * Open account addresses when redirected from /addresses
     */
    function redirectAddresses() {
        const
            currentUrl = window.location.href,
            urlParam = currentUrl.split('/'),
            urlAddresses = urlParam[urlParam.length - 1] === 'addresses' ? true : false

        if (urlAddresses === true) {
            location.href = '/account'
        }

        const prevUrl = document.referrer
        const prevUrlParam = prevUrl.split('/')
        const prevUrlAddresses = prevUrlParam[prevUrlParam.length - 1] === 'addresses' ? true : false

        if (prevUrlAddresses === true) {
            window.theme.openAddresses = true
            dispatchEvent('addresses:open')
        }
    }
    redirectAddresses()

    // Fetch products
    function fetchAllProducts() {
        let i = 1,
            urls = []

        do {
            urls.push(fetch(`/collections/all?view=data&page=${i}`))
            i++
        } while (i <= window.theme.allProductsPageCount)

        Promise.all(urls).then(responses =>
            Promise.all(responses.map(res => res.json()))
        ).then(data => {
            data = [].concat.apply([], data)

            window.products = data
            localStorage.setItem('allProducts', JSON.stringify(data)) // Save in localStorage
            setCookie('linkedFetched', true, 30)

            dispatchEvent('all-products:fetched', {allProducts: JSON.parse(localStorage.getItem('allProducts'))})
        })

    }

    // Fetch product if not saved already
    if (!localStorage.getItem('allProducts') || !getCookie('linkedFetched')) {
        fetchAllProducts()
    } else {
        window.products = JSON.parse(localStorage.getItem('allProducts'))

        // Check if product count has changed
        if (window.theme.allProductsCount === window.products.length) {
            dispatchEvent('all-products:fetched', {allProducts: JSON.parse(localStorage.getItem('allProducts'))})
        } else fetchAllProducts()
    }
})

